//the initialize
angular.module('emailoptoutModule', ['ui.bootstrap','ttcmExtensionsModule','cacheManagerModule'])
    .service('emailoptoutService', ['$q', 'cacheManagerService', emailoptoutService])
    .controller('emailoptoutController', ['$q','$scope', 'ttcmExtensionsService', 'emailoptoutService', emailoptoutController]);
